module.exports = __webpack_public_path__ + "static/img/3.7c72768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/3.png
// module id = JMc0
// module chunks = 1